import { PocComponentFooter, PocPagination } from 'commons/components/components-wrapper';
import { DEFAULT_PAGINATION_SIZES } from 'core/constants/constants';
import { useTranslation } from 'core/i18n/i18n';
import { PaginationProps } from './custom-table.type';
import { FooterContainer } from './custom-table.style';

interface CustomTableFooterComponentProps {
    paginationProps?: PaginationProps;
    totalElements: number;
    isLoading: boolean;
}

export const CustomTableFooterComponent: React.FC<CustomTableFooterComponentProps> = (props) => {
    const { paginationProps, totalElements, isLoading } = props;
    const { t } = useTranslation();

    return (
        <FooterContainer>
            {paginationProps && totalElements > DEFAULT_PAGINATION_SIZES[0] ? (
                <PocComponentFooter>
                    <PocPagination
                        page={paginationProps.currentPage}
                        total={Math.ceil(totalElements / paginationProps.pageSize)}
                        pageSize={paginationProps.pageSize}
                        pageSizeOptions={DEFAULT_PAGINATION_SIZES}
                        onPageChange={(ev) => paginationProps.onPageChange(ev.detail)}
                        inputProps={{ disabled: isLoading }}
                        selectDropdownProps={{ disabled: isLoading }}
                    >
                        <div slot="rows-per-page">
                            {t('modules.operators.pods.operators-list.table.pagination.rows')}
                        </div>
                        <div slot="indicator">
                            {t('modules.operators.pods.operators-list.table.pagination.pages', {
                                current: paginationProps.currentPage,
                                total: Math.ceil(totalElements / paginationProps.pageSize),
                            })}
                        </div>
                    </PocPagination>
                </PocComponentFooter>
            ) : undefined}
        </FooterContainer>
    );
};
